<template>
    <div  class="order">
        <van-panel >
            <van-nav-bar slot="header" style="color: #666">
                <div slot="left">

                    {{order.commodity_name}}
                </div>
                <div slot="right" style="font-size: small">
                    {{order.order_form_data}}
                </div>
            </van-nav-bar>
            <div  @click="orderDetail(order.order_form_number)">
                <van-panel :title="order.order_form_number"
                           :status="order.payment_status">
                    <van-card v-for="(good,index0) in order.goods"
                              :title="good.title"
                              :desc="good.standard"
                              :num="good.count"
                              :price="good.price"
                              :thumb="good.thumb"
                              :key="index0"
                    />
                    <div slot="footer" class="van-clearfix" style="color: #666">
                        <div style="float: right;font-size: small">
                            收货人: {{order.receiver}} &nbsp;&nbsp;合计 : <span style="color:red;">￥{{order.total_price}}</span>
                            (含运费{{order.freight}})
                        </div>
                    </div>
                </van-panel>
            </div>
            <div slot="footer" class="van-clearfix" style="color: #666;font-size: 12px">
                <div style="float: right">
                    <van-button class="pay" size="small" v-if="order.payment_status === '待付款'"
                                @click="goPay(order.order_form_number)">立即支付
                    </van-button>
                    <van-button class="buy-again" size="small" v-if="order.payment_status === '待付款' || order.payment_status === '待扣款'"
                                @click="cancelOrder(order.order_form_number)">取消订单
                    </van-button>
                    <img v-if="order.payment_status  === '支付审核'" src="/assets/images/paid.png" style="width: 40px"/>
                    <img v-else-if="order.payment_status === '已确认'" src="/assets/images/confirmed.png" style="width: 40px"/>&nbsp;&nbsp;
                    <!-- <van-button class="buy-again" size="small"  v-if="order.payment_status === '已付款' || order.payment_status === '已确认' || order.payment_status === '已完成'" @click="goDelivery(order.order_form_number)">
                        物流信息
                    </van-button> -->
                    <van-button class="buy-again" size="small"  v-if="order.payment_status != '待付款' && order.payment_status != '待扣款'" @click="goHome">
                        再次购买
                    </van-button>
                    <van-button class="buy-again2" size="small" @click="oneMoreOrder(order.order_form_number)">
                        再来一单
                    </van-button>
                </div>
                <van-popup v-model="show" round position="bottom" :style="{ height: '30%' }" />
            </div>
        </van-panel>
    </div>
</template>
<script>
    import { oneMoreOrder } from "../api/order/index";
    export default {
        props:{
            order:Object
        },
        data() {
            return {
                show: false
            }
        },
        methods: {
            orderDetail(code) {
                this.$router.push({path: 'order-details', query: {code: code}});
            },
            cancelOrder(orderNo){
                this.$dialog.confirm({
                    message: '确认取消订单?'
                }).then(() => {
                    this.$emit('cancel',orderNo)
                }).catch(() => {
                    // on cancel
                });
            },
            goPay(code) {
                console.log(code)
                this.$emit('goPay', code)
            },
            goHome(){
             this.$router.push('home')
            },
            goDelivery(orderNum) {
                this.show = true;
            },
            oneMoreOrder(orderNo){
                oneMoreOrder(orderNo, () => {
                    this.$toast("再来一单操作成功!");
                    this.$router.push('carts');
                    },
                    () => {
                        this.$toast("再来一单操作失败...");
                    }
                );

            }

        }
    }
</script>
<style lang="less" scoped>
    .pay {
        background: #FF3030;
        color: #FFFFFF;
        /*border-radius: 10px;*/
        margin-top: 3px;
    }

    .payed {
        color: #FF3030;
    }

    .buy-again {
        border-color: #FF3030;
        /*border-radius: 10px;*/
        float: right;
        margin-top: 3px;
    }
    .buy-again2 {
        border-color: #FF3030;
        float: right;
        margin-top: 3px;
        margin-right: 5px;
    }
</style>